var KEYS = require('./keys'),
	STORES = {
		hash: require('./stores/hashStore'),
		memory: require('./stores/memoryStore'),
		localStorage: require('./stores/localStorageStore'),
		session: require('./stores/sessionStore'),
		cookie: require('./stores/cookieStore')
	};

var listeners = {},
	pubsub = require('events/pubsub');

function getStoreForKey(key) {
	if (!(key in KEYS)) {
		throw new Error('Key "' + key + '" not registered in keys.js!');
	}

	var storeName = KEYS[key].store || KEYS[key];

	if (!(storeName in STORES)) {
		throw new Error('Unknown store "' + storeName + '" for key "' + key + '"');
	}

	return STORES[storeName];
}

function triggerChangeListeners(key, value) {
	var listenersForKey = listeners[key];

	if (listenersForKey) {
		listenersForKey.forEach(function (listener) {
			listener(value, false);
		});
	}
}

pubsub.subscribe('store-changed', function (data) {
	triggerChangeListeners(data.key, data.value);
});

module.exports = {
	get: function (key) {
		var store = getStoreForKey(key);

		return store.get.apply(store, arguments);
	},

	/**
	 * Set value(s) for specified key(s).
	 *
	 * @param  {Object|String} key    Key to set, or Object of key\value pairs to set.
	 *                                Objects must have keys that all belong to the same store!
	 * @param  {String}        value  Value to set for specified key. (optional if 'pairs' is an Object)
	 * @param  {Boolean}       silent Whether or not this change should fire a corresponding change event.
	 *
	 * @return {Object}               'this' for chaining purposes.
	 */
	set: function (key, value, silent) {
		var store, lastStore;

		if (key !== null && typeof key === 'object') {
			for (var k in key) {
				store = getStoreForKey(k);

				if (lastStore && store !== lastStore) {
					throw new Error('Objects must have keys that all belong to the same store!');
				}

				lastStore = store;
			}
		} else {
			store = getStoreForKey(key);
		}

		var changed = store.set.apply(store, arguments);

		if (!silent) {
			changed.forEach(function (kv) {
				triggerChangeListeners(kv.key, kv.value);
			});
		}

		return this;
	},

	remove: function (key, silent) {
		var store = getStoreForKey(key),
			changed = store.remove.apply(store, arguments);

		if (!silent && changed) {
			triggerChangeListeners(key, void 0);
		}

		return this;
	},

	/**
	 * Adds change listener.
	 *
	 * @param  {String}   	key Key to watch.
	 * @param  {Function} f Callback function, to be called like f(changedValue, isInitialCall);
	 *
	 * @return {Function}	Function that can be invoked to stop watching for changes.
	 */
	change: function (key, f) {
		var existingValue = this.get(key);

		listeners[key] = listeners[key] || [];

		listeners[key].push(f);

		function remove() {
			var a = listeners[key],
				l = a.length;

			while (l--) {
				if (a[l] === f) {
					a.splice(l, 1);

					if (!a.length) {
						delete listeners[key];
					}

					break;
				}
			}
		}

		f(existingValue, true);

		return remove;
	}
};
